function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import SpzaComponent from './../spzaComponent';
import { MediaType } from '../../Models';
import { convertTimeToSeconds, focusElement } from '../../utils/appUtils';
import { Constants } from '../../utils/constants';
let classNames = require('classnames-minimal');
let url = require('url');
class VideoModal extends SpzaComponent {
    componentDidMount() {
        // move focus to the cancel button
        // sets the document.activeElement to be the button
        focusElement(Constants.SearchBy.Id, this.initialFocusElementId);
    }
    getQueryString(query, exclude) {
        let result = '';
        const keys = query ? Object.keys(query) : [];
        const keysLength = keys.length;
        for(let i = 0; i < keysLength; i++){
            if (exclude && exclude.indexOf(keys[i]) < 0) {
                if (keys[i] && keys[i].toLowerCase() === 't') {
                    // When using youtube embed, the parameter "t" should be replaced with "start", and the value should be
                    // numeric only (according to youtube api - https://developers.google.com/youtube/player_parameters)
                    const startTimeInSeconds = isNaN(query[keys[i]]) ? convertTimeToSeconds(query[keys[i]]).toString() : query[keys[i]];
                    result += '&' + 'start' + '=' + startTimeInSeconds;
                } else {
                    result += '&' + keys[i] + '=' + query[keys[i]];
                }
            }
        }
        return result;
    }
    parseUrl(videoUrl) {
        let parsedUrl = url.parse(videoUrl, true);
        let hostName = '';
        let pathName = '';
        if (parsedUrl) {
            hostName = parsedUrl.hostname ? parsedUrl.hostname.toLowerCase() : hostName;
            // If the pathname doesn't start with "/", add "/" since in IE the pathname doesn't start with "/" which breaks the video url generating logic.
            pathName = (parsedUrl.pathname && parsedUrl.pathname.length > 0 && parsedUrl.pathname[0] !== '/' ? '/' : '') + parsedUrl.pathname;
        }
        return {
            hostname: hostName,
            pathname: pathName,
            query: parsedUrl ? parsedUrl.query : ''
        };
    }
    generateVideoSource() {
        let videoUrl = this.props.video.videoLink;
        let parsedUrl = this.parseUrl(videoUrl);
        let sourceUrl = '';
        if (parsedUrl.hostname.indexOf('youtube') >= 0 || parsedUrl.hostname.indexOf('youtu.be') >= 0) {
            if ((parsedUrl.hostname === 'www.youtube.com' || parsedUrl.hostname === 'youtube.com') && parsedUrl.query !== null && parsedUrl.query.v) {
                sourceUrl = this.youtubeEmbedTemplate + parsedUrl.query.v + '?' + this.getQueryString(parsedUrl.query, [
                    'v'
                ]);
            } else if (parsedUrl.hostname === 'youtu.be') {
                let pathValues = parsedUrl.pathname.split('/');
                if (pathValues.length > 1) {
                    sourceUrl = this.youtubeEmbedTemplate + pathValues[1] + '?' + this.getQueryString(parsedUrl.query);
                }
            } else if ((parsedUrl.hostname === 'www.youtube.com' || parsedUrl.hostname === 'youtube.com') && parsedUrl.pathname.indexOf('embed') >= 0) {
                sourceUrl = videoUrl;
                if (sourceUrl.indexOf('?') < 0) {
                    sourceUrl = sourceUrl + '?';
                }
            }
            // regardless, add the modesty params
            sourceUrl = sourceUrl + '&autoplay=1&showinfo=0&rel=0&modestbranding=1&cc_load_policy=1';
        } else if (parsedUrl.hostname.indexOf('vimeo') >= 0) {
            // we are doing a naive parse here
            const vimeoParsingRegex = /vimeo\.com\/(video\/)?(external\/)?(\d+)/;
            const matches = videoUrl.match(vimeoParsingRegex);
            const vimeoId = matches && matches.length && matches[matches.length - 1] || 'vimeoId';
            sourceUrl = this.vimeoEmbedTemplate + vimeoId + '?' + this.getQueryString(parsedUrl.query) + '&autoplay=1';
        }
        // our redirect
        if (parsedUrl.hostname === 'aka.ms') {
            sourceUrl = videoUrl;
        }
        return sourceUrl;
    }
    renderImpl() {
        let sourceUrl = this.generateVideoSource();
        const videoDialogClasses = classNames({
            spza_videoClass: true,
            videoDisplay: sourceUrl !== ''
        });
        return /*#__PURE__*/ _jsx("div", {
            role: "dialog",
            "aria-label": "video is now open",
            className: videoDialogClasses,
            children: /*#__PURE__*/ _jsxs("div", {
                className: "dialogContent",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "toolBar",
                        children: /*#__PURE__*/ _jsx("button", {
                            className: "cancel",
                            "aria-label": "close",
                            onClick: this.props.dismissModal,
                            "data-bi-id": "cancelButton",
                            "data-bi-name": MediaType.Video,
                            autoFocus: true,
                            children: /*#__PURE__*/ _jsx("span", {
                                className: "c-glyph"
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "videoContainer",
                        children: sourceUrl !== '' ? /*#__PURE__*/ _jsx("iframe", {
                            title: this.props.video.videoName ? this.props.video.videoName : 'Video',
                            width: "100%",
                            height: "100%",
                            src: sourceUrl,
                            frameBorder: 0
                        }) : /*#__PURE__*/ _jsx("img", {
                            src: this.props.video.thumbnailURL
                        })
                    })
                ]
            })
        });
    }
    constructor(...args){
        super(...args), _define_property(this, "youtubeEmbedTemplate", 'https://www.youtube.com/embed/'), _define_property(this, "vimeoEmbedTemplate", 'https://player.vimeo.com/video/'), _define_property(this, "initialFocusElementId", 'cancelButton');
    }
}
export { VideoModal as default };
VideoModal.contextTypes = {
    loc: PropTypes.func,
    renderErrorModal: PropTypes.func
};
